<mat-dialog-content>
	<h2>{{ planning.title }}</h2>
	<dl>
		<ng-container *ngIf="planning.client_id">
			<dt>Klant:</dt>
			<dd><a (click)="redirect(planning.client_id)">{{ planning.company_name }}</a></dd>
		</ng-container>
		<dt>Agenda type:</dt>
		<dd>{{ planning.type_name }}</dd>
		<ng-container *ngIf="planning.type !== 'meeting'">
			<dt>Rapportage type:</dt>
			<dd>{{ planning.report_type_name }}</dd>
		</ng-container>
		<dt>Start:</dt>
		<dd>{{ planning.start_at | date:'d.MM.yy HH:mm' }}</dd>
		<dt>Einde:</dt>
		<dd>{{ planning.end_at | date:'d.MM.yy HH:mm' }}</dd>
		<dt>Notitie:</dt>
		<dd>{{ planning.notes }}</dd>
	</dl>
</mat-dialog-content>
<mat-dialog-actions>
	<button mat-button color="grey" mat-dialog-close>SLUITEN</button>
</mat-dialog-actions>
